import {PrivatePage} from "./private/private.page";
import {ProtectedGuard, PublicGuard} from "ngx-auth";
import {RouterModule, Routes} from "@angular/router";
import {privateRoutes} from "./private/private.route";
import {authenticationRoutes} from "./authentication/authenticaton.route";
import {PublicPage} from "./public/public.page";
import {publicRoutes} from "./public/public.route";
import {ExtractKeyGuard} from "./shared/_helpers/extract-key.guard";



const approutes: Routes = [
    {
        path: 'public',
        component: PublicPage,
        canActivate: [PublicGuard],
        children: [
            // @ts-ignore
            {path: '', children: [...publicRoutes]}
        ]
    },

    // App routes

    {
        path: 'private',
        // component: DataPage,
        canActivate: [ExtractKeyGuard, ProtectedGuard],
        children: [
            // @ts-ignore
            {
                path: '',
                children: [...privateRoutes]
            },


        ]
    },


    // Authentification routes
    {
        path: 'authentication',
        children: [
            {path: '', children: [...authenticationRoutes]},

        ],

    },

    // { path: 'redirectTo', component: RedirectComponent }, // Use RedirectComponent for handling the redirection

    { path: '**', redirectTo: 'private/main/dashboard' }

];


export const appRoutes = RouterModule.forRoot(approutes);
